'use strict';
if (!window.Promise) {
  require('es6-promise').polyfill();
}
import axios from 'axios';

function validate() {
  return axios.get(`/_api/marketing-cookie-notification/allowed`);
}

export {validate};



// WEBPACK FOOTER //
// ./modules/geoValidator.js